import { gql, useMutation } from "@apollo/client"
import { StaffProcessHighwayFragment } from "~/adminApp/queries/fragments/StaffProcessHighwayFragment"
import { Mutation, MutationUploadAgreementArgs } from "@oysterhr/schema"
import { AgreementDetailsFragment } from "../fragments/AgreementDetailsFragment"

const UploadAgreementMutation = gql`
  mutation UploadAgreement($input: UploadAgreementInput!) {
    uploadAgreement(input: $input) {
      employment {
        id
        hiring {
          id
          agreements {
            ...AgreementDetails
          }
          isAgreementESignEnabled
          isOsaSigned
          ...ProcessHighway
        }
        invitation {
          sentAt
        }
      }
      engagement {
        id
        termination {
          id
          agreements {
            ...AgreementDetails
          }
        }
      }
      errors
    }
  }
  ${AgreementDetailsFragment}
  ${StaffProcessHighwayFragment}
`

export function useUploadAgreementMutation() {
  return useMutation<{ uploadAgreement: Mutation["uploadAgreement"] }, MutationUploadAgreementArgs>(
    UploadAgreementMutation,
  )
}
